/**
 * Every route pattern the app answers to, in one place.
 *
 * Lives in `shared/` rather than next to `routeConfig.tsx` because it is read from both
 * directions: `app/routes` mounts these, and code far below that layer needs to *name* a
 * destination — `features/push-admin` builds the target of a push notification out of them, and
 * FSD forbids a feature importing from `app/`. `app/routes/paths.ts` re-exports this, so the
 * router-side call sites read the same object under the name they always had.
 *
 * Patterns, not URLs: the `:param` segments are for `routeConfig` and for anything that
 * substitutes them deliberately. To *navigate*, use `shared/config/routes.ts`.
 */
export const PATHS = {
  login: "/login",
  workOrderPage: "/work-orders",
  workOrderCreate: "/work-orders/new",
  admin: "/admin",
  zeitmanagement: "/zeitmanagement",
  zeitmanagementCreate: "/zeitmanagement/new",
  // `:absenceId` is the Absence row, never a ScheduleEntry id — both pages load it with
  // `useAbsenceDetail`. The param used to be called `:entryId`, and the worker calendar duly
  // handed it `entry.id`, which is a different row.
  zeitmanagementEdit: "/zeitmanagement/:absenceId/edit",
  aufgaben: "/aufgaben",
  aufgabenPlan: "/aufgaben/plan",
  reschedule: "/reschedule",
  disposition: "/disposition",
  workOrderDetail: "/work-orders/:workOrderId",
  users: "/users",
  userCreate: "/users/new",
  userEdit: "/users/:userId/edit",
  workerCalendar: "/worker/calendar",
  workerPrivatzeit: "/worker/privatzeit",
  workerAppointment: "/worker/appointments/:appointmentId",
  workerZeitmanagementEdit: "/worker/zeitmanagement/:absenceId/edit",
  workerTask: "/worker/tasks/:taskId",
  controlling: '/controlling',
  dashboard: '/dashboard',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  userGuide: '/anleitung',
  userGuideTopic: '/anleitung/:slug',
  settings: '/admin/settings',
  settingsMail: '/admin/settings/mail',
  settingsPush: '/admin/settings/push',
  arbeitszeitReport: '/arbeitszeit-report',
} as const;
